<template>
    <div ref="rootElement">
        <template v-if="!enabled || loaded">
            <slot></slot>
        </template>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        rootMargin: {
            type: String,
            default: '0px',
        },
        enabled: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['loaded'],
    data() {
        return {
            loaded: false,
        }
    },

    mounted() {
        if (typeof window !== 'undefined' && window.IntersectionObserver) {
            const rootElement = this.$refs.rootElement
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(({ isIntersecting }) => {
                        if (isIntersecting) {
                            this.$emit('loaded')
                            this.loaded = true
                            observer.disconnect()
                        }
                    })
                },
                { rootMargin: this.rootMargin }
            )

            observer.observe(rootElement)
        }
    },
}
</script>
